// extracted by mini-css-extract-plugin
export default {"backtotop":"_2wZPE","open":"_3UyLB","btn":"_2GRef"};